import { connect } from "react-redux";
import SiteLog from "./siteLog";
import { bindActionCreators } from "redux";
import {
  getSiteLog
} from "services/redux/installation/siteLog/action";

const mapStateToProps = (state) => ({
  siteLog: state.siteLogReducer.siteLog,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteLog
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SiteLog);
